import { EditEventPage } from "./EditEventPage";

export default EditEventPage;
